module.exports = "<ea-role-detail-page></ea-role-detail-page>\n"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaSettings/eaRole/eaRoleDetailPage/eaRoleDetailPageModule.html
// module id = 1063
// module chunks = 12